import React from "react";

import { previewClientDocument } from "../api/clientDocumentApi";

const DocumentPreviewModal = ({
  show,
  docId,
  fileName,
  onClose
}) => {

  if (!show) return null;

const fileUrl = previewClientDocument(docId);


  const isImage =
    fileName?.match(/\.(jpg|jpeg|png)$/i);

  return (
    <div className="modal-overlay">

      <div className="modal-content">

        <div className="modal-header">
          <h5>{fileName}</h5>

          <button onClick={onClose}>
            ✖
          </button>
        </div>

        <div className="modal-body">

          {isImage ? (
            <img
              src={fileUrl}
              alt="Preview"
              style={{ width: "100%" }}
            />
          ) : (
            <iframe
              src={fileUrl}
              title="Document Preview"
              width="100%"
              height="600px"
            />
          )}

        </div>

      </div>

    </div>
  );
};

export default DocumentPreviewModal;
